import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    zIndex: 1000,
    position: 'absolute',
    right: '25px',
    top: '75px',
    width: '400px',
    height: '600px',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    boxShadow: theme.shadows[3],
    padding: theme.spacing(2),
  },
  chatContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  chatHeader: {
    flexShrink: 0,
  },
  messagesContainer: {
    flexGrow: 1,
    overflow: 'hidden',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: theme.spacing(2),
      background: 'linear-gradient(to bottom, #FFFFFF, rgba(255,255,255,0))',
      pointerEvents: 'none',
      zIndex: 1,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: theme.spacing(2),
      background: 'linear-gradient(to top, #FFFFFF, rgba(255,255,255,0))',
      pointerEvents: 'none',
      zIndex: 1,
    },
  },
  messages: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    gridGap: theme.spacing(2),
  },
  chatActions: {
    flexShrink: 0,
    paddingTop: 0,
  },
  textField: {
    width: '100%',
    backgroundColor: '#F5F5F5',
    borderColor: '#0563C1',
    borderRadius: '4px',
  },
}))

export default styles
